import React from "react"
import AccountStore from "../../stores/AccountStore"
import { Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn } from "material-ui"
import TF from "material-ui/Table/TableFooter"
import { IPunchSetRecordDto, EPunchSetApprovalType, EExceptionType, IUserDocument, IPunchSetDocument, EExceptionUITypes, EExceptionReviewDialogExceptionType, IQuestionDocument, IShiftExceptionDocument, IDate } from "../../models"
import TableFooter from "../layout/TableFooter"
import strings from "../../localization/strings"
import ExceptionsCol from "./ExceptionsCol"
import PunchImageToolTipColumn from "../punch/PunchImageToolTipColumn"
import PunchMapToolTipColumn from "../punch/PunchMapToolTipColumn"
import * as utils from "../../helpers/utils"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import ApproveIcon from "../approve/ApproveIcon"
import { red500 } from "material-ui/styles/colors"
import TimecardPunchControl from "../timecard/TimecardPunchControl"
import { browserHistory } from "react-router"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as userHelper from "../../helpers/userHelper"
import * as setGlobalHierarchyLevel from "../../helpers/setGlobalHierarchyLevel"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import autobind from "class-autobind"
import * as api from "../../api"
import AppStateStore from "../../stores/AppStateStore"
import PunchSetQuestionAnswerIcon from "../punch/punch_question_answer_detail/PunchSetQuestionAnswerIcon"
import * as timeHelper from "../../helpers/timeHelper"
import moment from "moment"

interface IProps {
    selectedFilterTypes: EExceptionUITypes[]
    exceptionPunchSetRecordsDto: any[]
    pagination: boolean
    total?: number
    page?: number
    limit?: number
    limitOptions?: number[]
    onPageClick?(page: number): void
    onLimitChange?(limit: number): void
    onAddPunch(punchSetRecordDto: IPunchSetRecordDto): void
    onApprovePunchSet(punchSetRecordDto: IPunchSetRecordDto): void
    handleShowExceptionDailog(exceptionType: EExceptionReviewDialogExceptionType, exceptionPunchId: string): void
}
interface IState {
    exceptionPunchSetRecordsDto: any[]
    questionDocs: IQuestionDocument[]
}

export default class ExceptionPunchSetsTable extends React.Component<IProps, IState> {
    private questionIds: string[] = []
    constructor(props: IProps) {
        super(props)
        this.state = {
            exceptionPunchSetRecordsDto: props.exceptionPunchSetRecordsDto,
            questionDocs: []
        }
        autobind(this)
    }

    async componentDidMount() {
        this.getQuestions(this.props)

        const exceptionPunchSetRecordsDto = await Promise.all(
            this.state.exceptionPunchSetRecordsDto.map(async item => {
                let punchInTime: IDate = null
                let punchOutTime: IDate = null
                let schedInTime: IDate = null
                let schedOutTime: IDate = null
                if (item.PunchSet) {
                    punchInTime = timeHelper.keepConvertUTCToLocal(item.PunchSet.RoundingRuleId ?
                        item.PunchSet.RoundedPunchInTimeLocal :
                        item.PunchSet.PunchInTimeLocal
                    )
                }
                if (item.PunchOut) {
                    punchOutTime = timeHelper.keepConvertUTCToLocal(item.PunchOut && item.PunchSet.RoundingRuleId ?
                        item.PunchSet.RoundedPunchOutTimeLocal :
                        item.PunchSet.PunchOutTimeLocal
                    )
                }
                if (!item.PunchSet) {
                    const shiftItem = item as IShiftExceptionDocument
                    schedInTime = await timeHelper.getDateTime(shiftItem.HierarchyId, shiftItem.JobId, shiftItem.BreakId ? shiftItem.BreakStartDateTime : shiftItem.ShiftStartDateTime)
                    schedOutTime = await timeHelper.getDateTime(shiftItem.HierarchyId, shiftItem.JobId, shiftItem.BreakId ? shiftItem.BreakEndDateTime : shiftItem.ShiftEndDateTime)
                }
                else {
                    const ps = item.PunchSet as IPunchSetDocument
                    schedInTime = ps.ScheduleInfo && await timeHelper.getDateTime(ps.HierarchyItemId, ps.JobId, ps.ScheduleInfo.ShiftStartDateTime as string)
                    schedOutTime = ps.ScheduleInfo && await timeHelper.getDateTime(ps.HierarchyItemId, ps.JobId, ps.ScheduleInfo.ShiftEndDateTime as string)
                }

                item.PunchInTime = punchInTime
                item.PunchOutTime = punchOutTime
                item.SchedInTime = schedInTime
                item.SchedOutTime = schedOutTime
                return item
            })
        )
        this.setState({ exceptionPunchSetRecordsDto })
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.getQuestions(nextProps)
    }

    getQuestions(props: IProps) {
        const questionIds: string[] = []
        props.exceptionPunchSetRecordsDto.forEach(i => {
            if (i.PunchSet) {
                i.PunchIn.Btn1Ids && i.PunchIn.Btn1Ids.length > 0 &&
                    i.PunchIn.Btn1Ids.forEach(e => !questionIds.includes(e) && questionIds.push(e))
                i.PunchIn.Btn2Ids && i.PunchIn.Btn2Ids.length > 0 &&
                    i.PunchIn.Btn2Ids.forEach(e => !questionIds.includes(e) && questionIds.push(e))
                i.PunchOut && i.PunchOut.Btn1Ids && i.PunchOut.Btn1Ids.length > 0 &&
                    i.PunchOut.Btn1Ids.forEach(e => !questionIds.includes(e) && questionIds.push(e))
                i.PunchOut && i.PunchOut.Btn2Ids && i.PunchOut.Btn2Ids.length > 0 &&
                    i.PunchOut.Btn2Ids.forEach(e => !questionIds.includes(e) && questionIds.push(e))
            }
        })

        if (questionIds.find(i => !this.questionIds.includes(i))) {
            this.questionIds = questionIds
            api.getQuestionsByQuestionGUIDs(this.questionIds).then(res =>
                this.setState({ questionDocs: res.data })
            )
        }
    }

    onClickEmployeeCol(item) {
        if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees)) return
        const userId = item.PunchSet ? item.PunchSet.UserId : item.UserId
        api.getUser(userId).then(res => {
            const user = res.data as IUserDocument
            user.Deleted ?
                AppStateStore.setProgressSnackbarContent(strings.This_employee_has_been_deleted) :
                browserHistory.push("/user-details/" + userId + "/timecards")
        })
    }

    render() {
        return (
            <div>
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn className="TextOverflow" title={strings.Exceptions} style={styles.exceptionCol}>{strings.Exceptions}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.In_Img} style={styles.toolTipCol}>{strings.In_Img}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.In_Map} style={styles.toolTipCol}>{strings.In_Map}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.In_Bio} style={styles.toolTipCol}>{strings.In_Bio}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.Out_Img} style={styles.toolTipCol}>{strings.Out_Img}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.Out_Map} style={styles.toolTipCol}>{strings.Out_Map}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.Out_Bio} style={styles.toolTipCol}>{strings.Out_Bio}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.paddingCol}>{strings.Employee}</TableHeaderColumn>
                            <TableHeaderColumn className="TextOverflow" title={strings.Hierarchy} style={styles.paddingCol}>{strings.Hierarchy}</TableHeaderColumn>
                            {AccountStore.getPunchQuestionEnabled() &&
                                <TableHeaderColumn className="TextOverflow" title={strings.QA} style={styles.approvedCol}>{strings.QA}</TableHeaderColumn>
                            }
                            {AccountStore.getEmployeeApproveTimecardEnabled() &&
                                <TableHeaderColumn className="TextOverflow" style={styles.approvedCol} title={strings.EMP_Approved}>{strings.Abbreviation_EMP_Approved}</TableHeaderColumn>
                            }
                            <TableHeaderColumn className="TextOverflow" style={styles.approvedCol} title={strings.Sup_Approved}>{strings.Abbreviation_Supervisor_Approved}</TableHeaderColumn>
                            {AccountStore.getScheduleEnabled() &&
                                <TableHeaderColumn className="TextOverflow" title={strings.Sched_In} style={styles.timeCol}>{strings.Sched_In}</TableHeaderColumn>
                            }
                            <TableHeaderColumn className="TextOverflow" title={strings.Punch_In_Time} style={styles.timeCol}>{strings.Punch_In_Time}</TableHeaderColumn>
                            {AccountStore.getScheduleEnabled() &&
                                <TableHeaderColumn className="TextOverflow" title={strings.Sched_Out} style={styles.timeCol}>{strings.Sched_Out}</TableHeaderColumn>
                            }
                            <TableHeaderColumn className="TextOverflow" title={strings.Punch_Out_Time} style={styles.timeCol}>{strings.Punch_Out_Time}</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {this.state.exceptionPunchSetRecordsDto.map((item, index) => {
                            const hierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(item.PunchSet ? item.PunchSet.HierarchyItemId : item.HierarchyId)
                            const empApproveException = item.PunchSet && item.PunchSet.PunchExceptions.find(exception => exception.TypeEnum === EExceptionType.MISSING_EMPLOYEE_APPROVAL)
                            const supApproveException = item.PunchSet && item.PunchSet.PunchExceptions.find(exception => exception.TypeEnum === EExceptionType.MISSING_SUPERVISOR_APPROVAL)
                            const employeeName = item.PunchSet ? item.PunchSet.EmployeeName : item.UserName
                            const employeeExternalId = item.PunchSet ? item.PunchSet.EmployeeExternalId : item.UserExternalId
                            return (
                                <TableRow data-intercom-target={index === 0 && "ExceptionPunchTable-openItemDetails"} key={index}>
                                    <TableRowColumn style={styles.exceptionCol}>
                                        <ExceptionsCol
                                            selectedFilterTypes={this.props.selectedFilterTypes}
                                            exceptionItem={item}
                                            handleShowExceptionDailog={this.props.handleShowExceptionDailog}
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchIn && <PunchImageToolTipColumn punch={item.PunchIn} />}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchIn && <PunchMapToolTipColumn punch={item.PunchIn} />}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchIn && utils.getBiometricScore(item.PunchIn)}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchOut && <PunchImageToolTipColumn punch={item.PunchOut} />}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchOut && <PunchMapToolTipColumn punch={item.PunchOut} />}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.toolTipCol}>
                                        {item.PunchOut && utils.getBiometricScore(item.PunchOut)}
                                    </TableRowColumn>
                                    <TableRowColumn title={employeeName} style={{ ...styles.paddingCol, cursor: "default" }}>
                                        <div onClick={() => this.onClickEmployeeCol(item)}>
                                            {employeeName}
                                            <br />
                                            {employeeExternalId &&
                                                <span style={{ color: "rgb(158, 158, 158)", fontSize: 10 }}>Emp #: {employeeExternalId}</span>
                                            }
                                        </div>
                                    </TableRowColumn>
                                    <TableRowColumn title={hierarchyName} style={{ ...styles.paddingCol, cursor: "default", color: hierarchyName === strings.Hierarchy_Removed && red500 }}>
                                        <div
                                            onClick={() => {
                                                if (hierarchyName === strings.Hierarchy_Removed) return
                                                const hierarchyItemId = item.PunchSet ? item.PunchSet.HierarchyItemId : item.HierarchyId
                                                if (hierarchyItemId && hierarchyItemId !== HierarchySettingsStore.getGlobalLevelItemFilterId()) {
                                                    const hierarchyLevel = hierarchyHelper.getHierarchyItemById(hierarchyItemId)
                                                    const accessRight = userHelper.getSupervisorAccessPermissionForHierarchy(hierarchyLevel)
                                                    if (accessRight) {
                                                        browserHistory.push("/hierarchy/location")
                                                        setGlobalHierarchyLevel.setGlobalHierarchyLevel(hierarchyLevel)
                                                    } else {
                                                        AppStateStore.setProgressSnackbarContent(strings.You_cant_access_this_hierarchy_item)
                                                    }
                                                } else if (hierarchyItemId && hierarchyItemId === HierarchySettingsStore.getGlobalLevelItemFilterId()) {
                                                    browserHistory.push("/hierarchy/location")
                                                }
                                            }}
                                        >
                                            {hierarchyName}
                                        </div>
                                    </TableRowColumn>
                                    {AccountStore.getPunchQuestionEnabled() &&
                                        <TableRowColumn style={styles.approvedCol}>
                                            {item.PunchSet &&
                                                <PunchSetQuestionAnswerIcon
                                                    questionDocs={this.state.questionDocs}
                                                    punchSetRecord={item}
                                                />
                                            }
                                        </TableRowColumn>
                                    }
                                    {AccountStore.getEmployeeApproveTimecardEnabled() &&
                                        <TableRowColumn style={styles.approvedCol}>
                                            {item.PunchSet &&
                                                <ApproveIcon
                                                    identify={`EmpApprove${index}`}
                                                    toolTipPosition="bottom"
                                                    toolTipArrow="center"
                                                    approvalType={EPunchSetApprovalType.Employee}
                                                    width={14}
                                                    punchSets={[item.PunchSet]}
                                                    expenses={[]}
                                                />
                                            }
                                        </TableRowColumn>
                                    }
                                    <TableRowColumn style={styles.approvedCol}>
                                        {item.PunchSet &&
                                            <ApproveIcon
                                                identify={`SupApprove${index}`}
                                                toolTipPosition="bottom"
                                                toolTipArrow="center"
                                                approvalType={EPunchSetApprovalType.Supervisor}
                                                width={18}
                                                punchSets={[item.PunchSet]}
                                                expenses={[]}
                                                handleApproveStatus={supApproveException && permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.ApproveTimecards) ?
                                                    () => this.props.onApprovePunchSet(item) :
                                                    null
                                                }
                                            />
                                        }
                                    </TableRowColumn>
                                    {AccountStore.getScheduleEnabled() &&
                                        <TableRowColumn style={styles.timeCol}>{item.SchedInTime && moment(item.SchedInTime).format("M/D/YY h:mma").slice(0, -1)}</TableRowColumn>
                                    }
                                    <TableRowColumn style={styles.timeCol}>{item.PunchInTime && moment(item.PunchInTime).format("MM/DD/YY h:mma").slice(0, -1)}</TableRowColumn>
                                    {AccountStore.getScheduleEnabled() &&
                                        <TableRowColumn style={styles.timeCol}>{item.SchedOutTime && moment(item.SchedOutTime).format("MM/DD/YY h:mma").slice(0, -1)}</TableRowColumn>
                                    }
                                    <TableRowColumn style={styles.timeCol}>
                                        {item.PunchSet &&
                                            (item.PunchOut ?
                                                (item.PunchOutTime && moment(item.PunchOutTime).format("MM/DD/YY h:mma").slice(0, -1)) :
                                                permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.EditTimecards) ?
                                                    <TimecardPunchControl
                                                        hintText="+ ADD"
                                                        value={null}
                                                        onAddPunch={() => this.props.onAddPunch(item)}
                                                    /> :
                                                    "- - -"
                                            )
                                        }
                                    </TableRowColumn>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    {this.props.pagination &&
                        <TF>
                            <TableFooter
                                total={this.props.total}
                                offset={this.props.page}
                                limit={this.props.limit}
                                limitOptions={this.props.limitOptions}
                                onPageClick={this.props.onPageClick}
                                onLimitChange={this.props.onLimitChange}
                            />
                        </TF>
                    }
                </Table>
            </div>
        )
    }
}

const styles = {
    exceptionCol: {
        width: 85,
        paddingLeft: 2,
        paddingRight: 2,
    },
    toolTipCol: {
        width: 45,
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2
    },
    approvedCol: {
        width: 45,
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2
    },
    timeCol: {
        width: 100,
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2
    },
    paddingCol: {
        textAlign: "center",
        paddingLeft: 2,
        paddingRight: 2
    }
}